<template>
  <div class="review-details">
    <div v-if="!submittingPayment" class="gradient-panel">

      <sfi-divider>
        <span class="center step-text"> {{ strings.titlePage }}</span>
      </sfi-divider>

      <div class="content-area">
        <div class="callout">
          <div class="grid-x center">
            <div class="cell small-12">
              <h2 class="due-details" id="paymentAmount"> {{ paymentDetails.amount.value | currency }} </h2>
              <p class="review-details-descriptions">
                {{ strings.dueOn }} {{ dueDate }}
              </p>
            </div>
          </div>

          <div class="divider"></div>

          <div class="grid-x align-center">
            <div class="cell small-12 medium-6">

              <div class="grid-x">
                <div class="cell small-12 review-details-definition-spacing">
                  <div class="review-details-title"> {{ strings.policyNumber }} </div>
                  <div class="review-details-descriptions" id="policyNumberDetail"> {{ policyDetails.policyNumber }} </div>
                </div>

                <div class="cell small-12 show-for-small-only review-details-definition-spacing">
                  <div class="review-details-title"> {{ strings.address }} </div>
                  <div class="review-details-descriptions"> {{ policyDetails.abbreviatedAddress.street }}, {{ policyDetails.abbreviatedAddress.zip }} </div>
                </div>

                <div class="cell small-12">
                  <div v-if="paymentDetails.type === 'Card'">
                    <div class="small-12 review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.cardInformation.nameOnCard }} </div>
                      <div class="review-details-descriptions" id="nameOnCardDetail"> {{ paymentDetails.cardInfo.name }} </div>
                    </div>
                    <div class="small-12 review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.cardInformation.cardInformation }} </div>
                      <div class="review-details-descriptions" id="cardInfo"> {{ paymentType }} </div>
                    </div>
                    <div class="small-12 show-for-medium">
                      <div class="review-details-title"> {{ strings.cardInformation.expiration }} </div>
                      <div class="review-details-descriptions" id="expDate"> {{ expDate }} </div>
                    </div>
                    <div class="small-12 show-for-small-only review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.cardInformation.expiration }} </div>
                      <div class="review-details-descriptions" id="expDate"> {{ expDate }} </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="cell small-12 review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.eCheck.bankAccountHolderName }} </div>
                      <div class="review-details-descriptions" id="holderNameInfo"> {{ paymentDetails.bankInfo.holderName }} </div>
                    </div>
                    <div class="cell small-12 review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.eCheck.bankName }} </div>
                      <div class="review-details-descriptions" id="bankNameInfo"> {{ paymentDetails.bankInfo.bankName }} </div>
                    </div>
                    <div class="cell small-12 review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.eCheck.bankRoutingNumber }} </div>
                      <div class="review-details-descriptions" id="routingNumberInfo"> {{ paymentDetails.bankInfo.routing | maskedBankInfoRouting }} </div>
                    </div>
                    <div class="cell small-12 show-for-medium">
                      <div class="review-details-title"> {{ strings.eCheck.bankAccountNumber }} </div>
                      <div class="review-details-descriptions" id="accountNumber"> {{ paymentDetails.bankInfo.accountNumber | maskedBankInfoAccountNumber }} </div>
                    </div>
                    <div class="cell small-12 show-for-small-only review-details-definition-spacing">
                      <div class="review-details-title"> {{ strings.eCheck.bankAccountNumber }} </div>
                      <div class="review-details-descriptions" id="accountNumber"> {{ paymentDetails.bankInfo.accountNumber | maskedBankInfoAccountNumber }} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="cell small-12 medium-6">
              <div class="grid-x">

                <div class="cell small-12 show-for-medium review-details-definition-spacing">
                  <div class="review-details-title"> {{ strings.address }} </div>
                  <div class="review-details-descriptions" id="addressDetail" > {{ policyDetails.abbreviatedAddress.street }}, {{ policyDetails.abbreviatedAddress.zip }}</div>
                </div>

                <div class="cell small-12">
                  <div class="review-details-title"> {{ strings.billingInformation }} </div>
                  <div class="review-details-descriptions" id="billingInformation">
                    {{ fullBillingAddress[0] }} <br>
                    {{ fullBillingAddress[1] }} <br>
                    {{ fullBillingAddress[2] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-x align-middle review-buttons">
          <div class="cell medium-2 show-for-medium">
            <button class="button primary-blue clear" id="cancelButton" @click="cancelTransaction()" :name="analyticsConstants.CANCEL"> {{ strings.cancelButton }} </button>
          </div>
          <div class="button-group cell medium-4 show-for-medium align-right back-button-margin">
            <button class="button secondary fixed" id="backButton" @click="$router.back()" :name="analyticsConstants.reviewPayment.BACK"> {{ strings.backButton }} </button>
          </div>
          <div class="button-group cell small-12 medium-4 submit-button-margin">
            <button class="button primary-orange expanded-for-small-only submit-button-padding" id="confirmButton" @click="submit" :name="analyticsConstants.reviewPayment.CONFIRM_PAYMENT"> {{ strings.confirmButton }} </button>
          </div>
          <div class="button-group small-12 show-for-small-only align-center">
            <button class="button secondary expanded-for-small-only" @click="$router.back()" :name="analyticsConstants.reviewPayment.BACK"> {{ strings.backButton }} </button>
          </div>
          <div class="cell small-12 show-for-small-only center">
            <button class="button primary-blue clear" @click="cancelTransaction()" :name="analyticsConstants.CANCEL"> {{ strings.cancelButton }} </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="submitting gradient-panel">
      <div class="content-area">
        <sending-payment></sending-payment>
      </div>
    </div>
    <div class="hidden-form">
      <form :action="action" id="paymentForm" :method="method">
        <!-- General fields for the payment process -->
        <input type="hidden" name="token" v-model="paymentResource.gateway.token" />
        <input type="hidden" name="returnurl" v-model="returnUrl" />
        <input type="hidden" name="store" value="n" />
        <input type="hidden" name="action" value="sale" />
        <input type="hidden" name="name" v-model="payeeName" />
        <input type="hidden" name="address1" v-model="paymentDetails.billingInfo.address" />
        <input type="hidden" name="zip" v-model="paymentDetails.billingInfo.zip" />
        <input type="hidden" name="amount" v-model="paymentDetails.amount.value" />
        <input type="hidden" name="customfield1" v-model="paymentResource.policyNumber" />
        <input type="hidden" name="customfield3" v-model="paymentDetails.type" />
        <input type="hidden" name="ticket" v-model="ticketFieldContent" />
        <!-- Fields when payment type is equal to 'CARD' -->
        <input type="hidden" name="cc" v-model="paymentDetails.cardInfo.number" v-if="paymentDetails.type === 'Card'" />
        <input type="hidden" name="exp" v-model="paymentDetails.cardInfo.expiration" v-if="paymentDetails.type === 'Card'" />
        <input type="hidden" name="cvv" v-model="paymentDetails.cardInfo.cvv" v-if="paymentDetails.type === 'Card'" />
        <!-- Fields when payment type is equal to 'eCheck' -->
        <input type="hidden" name="routing" v-model="paymentDetails.bankInfo.routing" v-if="paymentDetails.type === 'eCheck'" />
        <input type="hidden" name="account" v-model="paymentDetails.bankInfo.accountNumber" v-if="paymentDetails.type === 'eCheck'" />
        <input type="hidden" name="media" value="ach" v-if="paymentDetails.type === 'eCheck'" />
      </form>
    </div>
  </div>
</template>

<script>
// Utils
import _ from 'lodash';
import moment from 'moment';
import cardValidator from 'card-validator';
import { mapState } from 'vuex';

// Strings
import descriptions from '../i18n/en/strings';

// Components
import SendingPayment from '@/components/shared/SendingPayment';

// Constants
import constants from '@/i18n/en/constants';

// Services
import AnalyticsService from '@/services/AnalyticsService';

export default {
  name: 'Review',
  components: {
    SendingPayment
  },
  created() {
    let validateFormData = this.$store.state.payment;
    if (validateFormData.type === 'Card') {
      let validateCardInfo = _.some(validateFormData.cardInfo, _.isEmpty);
      if (validateCardInfo === true) {
        this.redirectToPage('find-your-bill');
      }
    }
    if (validateFormData.type === 'eCheck') {
      let validateBankInfo = _.some(validateFormData.bankInfo, _.isEmpty);
      if (validateBankInfo === true) {
        this.redirectToPage('find-your-bill');
      }
    }
    window.scrollTo(0, 0);
  },
  data() {
    return {
      analyticsConstants: constants.analyticsConstants,
      strings: descriptions.review,
      policyDetails: this.$store.state.policyDetails,
      paymentResource: this.$store.state.paymentResource,
      paymentDetails: this.$store.state.payment,
      returnUrl: this.$store.state.returnUrl,
      todaysDate: moment().format('MMMM D, YYYY'),
      agreeToPay: false,
      acknowledgements: false,
      submittingPayment: false,
      action: this.$store.state.paymentResource.gateway.paymentUrl,
      method: this.$store.state.paymentResource.gateway.method,
      expDate: '',
      dueDate: moment().format('MMMM DD, YYYY')
    }
  },
  mounted() {
    this.formatCardExpDate();
    AnalyticsService.trackPageView(this.analyticsConstants.REVIEW_PAYMENT);
  },
  computed: {
    ...mapState(['insuranceType']),
    paymentType() {
      const cardInfo = _.get(cardValidator.number(this.paymentDetails.cardInfo.number), 'card');
      if (cardInfo) {
        return `${cardInfo.type.toUpperCase()} ending in ${this.paymentDetails.cardInfo.number.slice(-4)}`;
      } else {
        const bankInfo = this.paymentDetails.bankInfo;
        return `${bankInfo.bankName} ${bankInfo.accountType} account ending in ${bankInfo.accountNumber.slice(-4)}`;
      }
    },
    fullBillingAddress() {
      const billingInfo = this.paymentDetails.billingInfo;
      const fullName = billingInfo.firstName + ' ' + billingInfo.lastName;
      return [
        fullName, billingInfo.address,
        `${billingInfo.city}, ${billingInfo.state} ${billingInfo.zip}`
      ];
    },
    payeeName() {
      if (this.paymentDetails.type === 'Card') { // Payment type is Card
        return this.paymentDetails.cardInfo.name;
      } else { // Payment type is eCheck
        return this.paymentDetails.bankInfo.holderName;
      }
    },
    ticketFieldContent() {
      // If testMode is set to disable-duplicate-check, send a blank ticket field to disable duplicate payment check
      return (this.$store.state.testMode === 'disable-duplicate-check')
              ? ''
              : this.paymentResource.policyNumber + '$' + this.paymentDetails.amount.value;
    }
  },
  filters: {
    maskedBankInfoRouting: function (bankInfoRouting) {
      return bankInfoRouting.replace(/.(?=.{4})/g, '*');
    },
    maskedBankInfoAccountNumber: function (bankInfoAccountNumber) {
      return bankInfoAccountNumber.replace(/.(?=.{4})/g, '*');
    }
  },
  methods: {
    async submit() {
      window.scrollTo(0, 0);
      this.submittingPayment = true;
      this.$store.dispatch('UPDATE_PAYMENT_RESOURCE_SUBMIT_STARTED')
        .then((res) => {
          this.$store.dispatch('SET_VUEX_STATE_IN_SESSION_STORAGE');
          document.getElementById('paymentForm').submit();
        })
        .catch(() => {
          this.goToPage('error');
        });
    },
    cancelTransaction() {
      this.$store.dispatch('CANCEL_TRANSACTION');
      this.goToPage('find-your-bill');
    },
    formatCardExpDate() {
      this.expDate = this.paymentDetails.cardInfo.expirationMonth + ' / ' + this.paymentDetails.cardInfo.expirationYear.substr(-2);
    }
  }
}
</script>

<style lang="scss" type="scss" scoped>
@import '~@/styles/variables.scss';
$review-custom-font-weight: 400;
.review-details {

  .content-area {
    color: $black;
    font-size: $sfi-xs-font-size;
    position: relative;

    .review-details-title {
      font-weight: $global-weight-semibold;
      margin-bottom: 4px;
    }

    .review-details-definition-spacing {
      margin-bottom: 16px;
    }

    .due-details {
      color: $primary-color;
      text-align: center;
    }

    .review-details-descriptions {
      font-weight: $review-custom-font-weight;
    }

    .review-buttons {
      margin-top: 30px;

      @include breakpoint (medium) {
        .back-button-margin {
          margin-right: 5px;
        }
        .submit-button-margin {
          margin-left: 5px;
        }
      }
      .submit-button-padding {
        padding-left: 12px;
        padding-right: 12px;
      }
    }
  }

  .divider {
    background-color: $medium-gray;
    height: 1px;
    margin: 30px auto;
    width: 100%;
  }

  .callout {
    border: 2px solid $medium-gray;
    .grid-x {
      padding-bottom: 0px;
    }
  }

  .submitting.gradient-panel {
    border-image-slice: 1 1 1;
  }
}
.hidden-form {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Review.vue